import type { Timestamp } from "../interfaces/FirestoreTimestampIF"

const addZero = (num: number): string => {
  return ("00" + num).slice(-2)
}

export const convertDateToString = (timestamp?: Timestamp): string | null => {
  if (!timestamp) {
    return null
  }

  const date = new Date(timestamp._seconds * 1000)
  return `${date.getFullYear()}-${addZero(date.getMonth() + 1)}-${addZero(
    date.getDate(),
  )}`
}

export const convertTimestampToYmdhm = (
  timestamp?: Timestamp,
): string | null => {
  if (!timestamp) {
    return null
  }

  const date = new Date(timestamp._seconds * 1000)
  return `${date.getFullYear()}/${addZero(date.getMonth() + 1)}/${addZero(
    date.getDate(),
  )}
   ${addZero(date.getHours())}:${addZero(date.getMinutes())}
  `
}
